export default "__VITE_ASSET__BVtxs0fp__"